/**
 * Poza mare, adusă prin axios.
 *
 * Un `<img src="/api/…">` simplu ar pleca FĂRĂ antetul de autentificare — browserul nu trece
 * interceptorul peste marcajele de imagine — și ar lua 401. Același tipar ca la arhiva de
 * bannere.
 */
import { useEffect, useState } from 'react'
import { api } from '../../lib/api'

export function PozaMare({ id, alt }: { id: number; alt: string }) {
  const [url, setUrl] = useState<string | null>(null)
  const [eroare, setEroare] = useState(false)

  useEffect(() => {
    let anulat = false
    let creat: string | null = null
    api
      .get(`/marketing/poze/continut/${id}`, { responseType: 'blob' })
      .then((r) => {
        if (anulat) return
        creat = URL.createObjectURL(r.data as Blob)
        setUrl(creat)
      })
      .catch(() => {
        if (!anulat) setEroare(true)
      })
    return () => {
      anulat = true
      if (creat) URL.revokeObjectURL(creat)
    }
  }, [id])

  if (eroare) {
    return (
      <p className="flex flex-1 items-center justify-center text-sm text-white/70">
        Poza nu s-a putut aduce.
      </p>
    )
  }
  if (!url) {
    return (
      <p className="flex flex-1 items-center justify-center text-sm text-white/70">Se încarcă…</p>
    )
  }
  return (
    <img
      src={url}
      alt={alt}
      className="min-h-0 flex-1 object-contain"
      onClick={(e) => e.stopPropagation()}
    />
  )
}
